import type { CodeGroupFormValues } from '../../../../model'

export type DeductionField =
  | 'adjustments'
  | 'deductible'
  | 'coInsurance'
  | 'copayment'
  | 'nonCovered'

export interface GroupState {
  selectedPrefix: string | null
  selectedCarcCodes: string[]
  selectedRarcCodes: string[]
  payorSpecificCode: string
  amount: number | null
}

export const EMPTY_GROUP: GroupState = {
  selectedPrefix: null,
  selectedCarcCodes: [],
  selectedRarcCodes: [],
  payorSpecificCode: '',
  amount: null,
}

export interface UnifiedGroup {
  /** Server-assigned code group key for audit trail tracking */
  key: string | null
  state: GroupState
  collapsed: boolean
}

export function isGroupValid(g: GroupState): boolean {
  return g.selectedPrefix !== null && g.selectedCarcCodes.length > 0
}

/** Reverse-map a saved CodeGroupFormValues back into editable GroupState. */
export function codeGroupToGroupState(cg: CodeGroupFormValues): GroupState {
  const firstCarc = cg.carcs[0] ?? ''
  const match = firstCarc.match(/^([A-Z]+)(\d+)$/)
  const prefix = match?.[1] ?? null
  return {
    selectedPrefix: prefix,
    selectedCarcCodes: cg.carcs.map((c) => c.replace(/^[A-Z]+/, '')),
    selectedRarcCodes: [...cg.rarcs],
    payorSpecificCode: cg.payorSpecificCodes[0] ?? '',
    amount: cg.amount,
  }
}

/** Convert editable GroupState into the API-facing CodeGroupFormValues. */
export function groupStateToCodeGroup(
  eg: GroupState,
  key: string | null = null,
): CodeGroupFormValues {
  const prefix = eg.selectedPrefix ?? ''
  return {
    key,
    carcs: eg.selectedCarcCodes.map((code) => `${prefix}${code}`),
    rarcs: [...eg.selectedRarcCodes],
    payorSpecificCodes: eg.payorSpecificCode ? [eg.payorSpecificCode] : [],
    amount: eg.amount,
  }
}
